import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
export const About = () => {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black to-brand-charcoal" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-13">
          <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6 text-white" data-id="element-14">
            A Temple of Sound
          </h2>
          <div className="flex justify-center mb-10" data-id="element-15">
            <Logo data-id="element-16" />
          </div>
          <p className="text-xl leading-relaxed mb-8 text-white/90" data-id="element-17">
            Praise Karaoke is not a performance. It's Worship. Every note
            becomes an offering of praise. When we sing together, we lift our
            voices to God in fellowship and joy.
          </p>
          <p className="text-lg leading-relaxed text-white/70" data-id="element-18">
            This is a space where music becomes worship and hearts respond to
            God's presence. Where we gather in fellowship to celebrate the
            sacred act of raising our voices together in praise.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-19">
          {[{
          title: 'Sacred',
          description: 'Draw closer to God through the power of worship',
          icon: '✝️'
        }, {
          title: 'Joyful',
          description: 'Experience the joy and wonder of worshipful singing together',
          icon: '🙌'
        }, {
          title: 'Transformative',
          description: 'Be transformed as praise fills the room and hearts are renewed',
          icon: '🔥'
        }].map((item, index) => <div key={index} className="bg-brand-charcoal/50 p-8 rounded-lg text-center border border-brand-red/20" data-id="element-20">
              <div className="text-4xl mb-4" data-id="element-21">{item.icon}</div>
              <h3 className="font-display text-xl font-bold mb-3 text-white" data-id="element-22">
                {item.title}
              </h3>
              <p className="text-white/70" data-id="element-23">{item.description}</p>
            </div>)}
        </motion.div>
      </div>
    </section>;
};